export * from "./lavaMaterial.js";
//# sourceMappingURL=index.js.map